import { render, staticRenderFns } from "./questCategory.vue?vue&type=template&id=825ba15a"
import script from "./questCategory.vue?vue&type=script&lang=js"
export * from "./questCategory.vue?vue&type=script&lang=js"
import style0 from "./questCategory.vue?vue&type=style&index=0&id=825ba15a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports